import AnchorLink from './AnchorLink';
import InternalAnchor from './Anchor';
const Anchor = InternalAnchor;
Anchor.Link = AnchorLink;
export default Anchor;
